import { FC } from 'react'
import styled from 'styled-components'

import { UserRecurringAllowancesTable } from './UserRecurringAllowancesTable'
import { RecurringAllowanceForm } from './RecurringAllowanceForm'

import { Memberships } from 'Utils/types/benefitProgram'
import { CurrencyCode } from 'Utils/types/currencies'
import { spacingMD, spacingSM } from 'Utils/styles/spacing'
import { RecurringAllowance } from 'Utils/types/allowance'

const ProgramTitle = styled.h3`
  align-content: center;
  justify-content: center;
  margin: ${spacingMD} ${spacingSM};
`

type BenefitProgramRecurringAllowancesProps = {
  userId: number
  benefitProgramId: number
  membership: Memberships
  currencyCode: CurrencyCode
  disableCreation?: boolean
  editingRecurringAllowance: RecurringAllowance | null
  onEditRecurringAllowance: (recurringAllowance: RecurringAllowance | null) => void
}

export const BenefitProgramRecurringAllowances: FC<BenefitProgramRecurringAllowancesProps> = ({
  userId,
  benefitProgramId,
  membership,
  currencyCode,
  disableCreation = false,
  editingRecurringAllowance,
  onEditRecurringAllowance
}) => {
  return (
    <div>
      <ProgramTitle>
        Program {membership.programId} ({membership.programName})
      </ProgramTitle>
      <UserRecurringAllowancesTable
        key={membership.programId}
        userId={userId}
        benefitProgramId={benefitProgramId}
        onEditRecurringAllowance={onEditRecurringAllowance}
      />
      {!disableCreation && (
        <RecurringAllowanceForm
          userId={userId}
          benefitProgramId={benefitProgramId}
          currencyCode={currencyCode}
          editingRecurringAllowance={editingRecurringAllowance}
          onCancelEdit={() => onEditRecurringAllowance(null)}
        />
      )}
    </div>
  )
}
